"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Form_exports = {};
__export(Form_exports, {
  Form: () => Form,
  FormFrame: () => FormFrame,
  FormProvider: () => FormProvider,
  FormTrigger: () => FormTrigger,
  useFormContext: () => useFormContext
});
module.exports = __toCommonJS(Form_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_core = require("@tamagui/core");
var import_create_context = require("@tamagui/create-context");
var import_react = require("react");
const FORM_NAME = "Form";
const FormFrame = (0, import_core.styled)(import_core.Stack, {
  name: FORM_NAME,
  tag: "form"
});
const [createFormContext] = (0, import_create_context.createContextScope)(FORM_NAME);
const [FormProvider, useFormContext] = createFormContext(FORM_NAME);
const TRIGGER_NAME = "FormTrigger";
const FormTriggerFrame = (0, import_core.styled)(import_core.Stack, {
  name: TRIGGER_NAME
});
const FormTrigger = FormTriggerFrame.extractable(
  (0, import_react.forwardRef)(
    (props, forwardedRef) => {
      const { __scopeForm, children, ...triggerProps } = props;
      const context = useFormContext(TRIGGER_NAME, __scopeForm);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        FormTriggerFrame,
        {
          tag: "button",
          ...triggerProps,
          children: triggerProps.asChild ? (0, import_react.cloneElement)(children, { disabled: triggerProps.disabled }) : children,
          ref: forwardedRef,
          onPress: (0, import_core.composeEventHandlers)(props.onPress, context.onSubmit)
        }
      );
    }
  )
);
function FormComponent({
  onSubmit,
  ...props
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormProvider, { scope: props.__scopeForm, onSubmit, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormFrame, { ...props, onSubmit: (e) => e.preventDefault() }) });
}
const Form = (0, import_core.withStaticProperties)(FormFrame.extractable(FormComponent), {
  Trigger: FormTrigger
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Form,
  FormFrame,
  FormProvider,
  FormTrigger,
  useFormContext
});
//# sourceMappingURL=Form.js.map
